import { Popover } from '@mui/material';
import React from 'react';

import PopoverContent from './popover-content';

type SelectionPopoverProps = {
  anchorEl: HTMLDivElement | null;
  setAnchorEl: (anchorEl: HTMLDivElement | null) => void;
};

const sx = () => ({
  border: '1px solid #E8E8E8',
  borderRadius: '8px',
  boxShadow: '0px 2px 6px rgba(26, 25, 25, 0.1)',
});

function SelectionPopover({
  anchorEl,
  setAnchorEl,
}: Readonly<SelectionPopoverProps>) {
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 41,
      }}
      id={id}
      onClose={handleClose}
      open={open}
      slotProps={{
        paper: {
          sx,
        },
      }}
      transitionDuration={0}
    >
      <PopoverContent setAnchorEl={setAnchorEl} />
    </Popover>
  );
}

export default SelectionPopover;
